import { render, staticRenderFns } from "./AdminAnnouncements.vue?vue&type=template&id=9297f914"
import script from "./AdminAnnouncements.vue?vue&type=script&lang=js"
export * from "./AdminAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports